import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { checkLinkFileExtension, DynamicFileThumbnail } from "../../lms-shared/functions/DynamicFileThumbnail";
import FilesPopup from "../../lms-shared/UI/Popups/FilesPopup/FilesPopup";
import classes from "./LessonPlanView.module.css";

const LessonPlanView = ({ planContentPath, planContentType, contentData, filesBaseUrl }) => {
    const texts = useSelector(state => state.translate.texts);
    const descriptionsRef = useRef([]);
    const [filesPopup, setFilesPopup] = useState()

    const fileTypeSrc = {
        'PDF': '',
        'PowerPointOpenXML': `https://view.officeapps.live.com/op/embed.aspx?embedded=true&src=`
    };

    const openFiles = (auxiliary) => {
        if (auxiliary.Link) {
            checkLinkFileExtension(auxiliary.Link) ?
                setFilesPopup(<FilesPopup fileUrl={auxiliary.Link} title={auxiliary.Description} setMessage={setFilesPopup} />)
                : window.open(auxiliary.Link)
        }
        else {
            setFilesPopup(<FilesPopup fileUrl={`${filesBaseUrl}/${auxiliary.FileSubUrl}`} title={auxiliary.Description} setMessage={setFilesPopup} />)
        }
    }

    useEffect(() => {
        descriptionsRef.current = descriptionsRef.current.slice(0, contentData?.Attachments?.length);
        descriptionsRef.current.forEach((itemRef,) => {
            if (itemRef) {
                const element = itemRef;
                const arRegex = /[\u0600-\u06FF\u0750-\u077F]/;
                const heRegex = /[\u0590-\u05FF]/
                if (heRegex.test(element.textContent) || arRegex.test(element.textContent)) {
                    element.style.direction = 'rtl';
                }
            }
        });
    }, [contentData]);

    return (
        <>
            {planContentPath ? <iframe className={classes.Iframe} title="LessonPlanView" src={`${fileTypeSrc[planContentType]}${planContentPath}?notCache=${Math.floor(new Date().getTime())}`} height="100%" width="100%" /> :
                <div className={classes.Text}>{texts.planContentNotExist}</div>}
            {contentData && contentData.Attachments && contentData.Attachments.length > 0 &&
                <div className={classes.AuxiliaryMaterialsContainer}>
                    <hr className={classes.Saperator} />
                    <p className={classes.Title}>{texts.attachedAuxiliary}</p>
                    <div className={classes.AuxiliaryMaterials}>
                        {contentData.Attachments.map((a, index )=> {
                            const thumbnail = a.FileSubUrl ? DynamicFileThumbnail(a.FileSubUrl, filesBaseUrl) : a.Link ? DynamicFileThumbnail(a.Link) : null;
                            return <div className={classes.AuxiliaryMaterial} key={a.Id} onClick={() => openFiles(a)}>
                                <img className={classes.AuxiliaryMaterialImg} src={thumbnail} alt={thumbnail} />
                                <p className={classes.AuxiliaryMaterialText} ref={el => descriptionsRef.current[index] = el}>{a.Description}</p>
                            </div>
                        })}
                    </div>
                </div>}
            {filesPopup}
        </>
    )
}

export default LessonPlanView;